import { cx } from '@libs/classnames';

import styles from './ColorSquare.module.css';

export type Props = {
  className?: string;
  color: string;
};

export function ColorSquare({ className, color }: Props) {
  return <span style={{ background: color }} className={cx(className, styles.colorSquare)} />;
}
